import { render } from "./App.vue?vue&type=template&id=01235ba6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=01235ba6&lang=scss"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__